/*
  Journal: topic tabs and "Load more" fetch the real tagged / next-page URL through the Section Rendering
  API and swap or append the cards. Without JavaScript they are plain links.
*/
if (!customElements.get('sok-journal')) {
  class SokJournal extends HTMLElement {
    connectedCallback() {
      this.results = this.querySelector('[data-sok-journal-results]');
      document.addEventListener('click', (event) => {
        const topic = event.target.closest('[data-sok-journal-topic]');
        if (topic && !event.metaKey && !event.ctrlKey) {
          event.preventDefault();
          this.filter(topic);
          return;
        }
        const more = event.target.closest('[data-sok-journal-more]');
        if (more && this.contains(more) && !event.metaKey && !event.ctrlKey) {
          event.preventDefault();
          this.loadMore(more);
        }
      });
      window.addEventListener('popstate', () => this.load(location.href, false));
    }

    sectionUrl(href) {
      const url = new URL(href, location.origin);
      url.hash = '';
      url.searchParams.set('section_id', this.dataset.section);
      return url;
    }

    async fetchSection(href) {
      const response = await fetch(this.sectionUrl(href));
      if (!response.ok) throw new Error(response.status);
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    filter(link) {
      const fromOutside = !this.contains(link);
      this.markActive(link.dataset.sokJournalTopic);
      this.load(link.href, true);
      if (fromOutside) {
        const top = this.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }

    markActive(topic) {
      this.querySelectorAll('.sok-journal__tab').forEach((tab) => {
        const on = tab.dataset.sokJournalTopic.toLowerCase() === (topic || '').toLowerCase();
        tab.classList.toggle('is-active', on);
        if (on) tab.setAttribute('aria-current', 'page');
        else tab.removeAttribute('aria-current');
      });
    }

    async load(href, push) {
      this.results.classList.add('is-fading');
      const started = Date.now();
      try {
        const html = await this.fetchSection(href);
        const fresh = html.querySelector('[data-sok-journal-results]');
        // Let the fade-out finish before swapping.
        await new Promise((resolve) => setTimeout(resolve, Math.max(0, 220 - (Date.now() - started))));
        if (fresh) this.results.innerHTML = fresh.innerHTML;
        const active = html.querySelector('.sok-journal__tab.is-active');
        this.markActive(active ? active.dataset.sokJournalTopic : '');
        if (push) {
          const url = new URL(href, location.origin);
          url.hash = '';
          history.pushState({}, '', url);
        }
      } catch (e) {
        window.location.href = href;
        return;
      }
      this.results.classList.remove('is-fading');
    }

    async loadMore(button) {
      button.setAttribute('aria-busy', 'true');
      try {
        const html = await this.fetchSection(button.href);
        const grid = this.results.querySelector('[data-sok-journal-grid]');
        const cards = html.querySelectorAll('[data-sok-journal-grid] > *');
        cards.forEach((card) => {
          card.classList.add('sok-fade-in');
          grid.append(card);
        });
        const next = html.querySelector('[data-sok-journal-more]');
        if (next) {
          button.href = next.href;
          button.removeAttribute('aria-busy');
        } else {
          button.closest('.sok-journal__more')?.remove();
        }
        cards[0]?.focus?.();
      } catch (e) {
        window.location.href = button.href;
      }
    }
  }

  customElements.define('sok-journal', SokJournal);
}
